/**
 * Internal dependencies
 */
import { Reaction } from '@/event';

const getTotalReactionsCount = (reactions: Reaction[]) =>
	reactions.reduce((previous, current) => previous + current.count, 0);

export default getTotalReactionsCount;
